<script setup lang="ts">
import { useListsStore } from '@shared/model'
import { AppText } from '@shared/ui/typography'

import { useTutorKanbanStore } from '../model/store'
import TutorKanbanSelectStage from './kanban-fields/TutorKanbanSelectStage.vue'
import TutorKanbanPreviousStage from './TutorKanbanPreviousStage.vue'
import TutorKanbanSelectPriority from './kanban-fields/TutorKanbanSelectPriority.vue'
import TutorKanbanPickerDeadline from './kanban-fields/TutorKanbanPickerDeadline.vue'
import TutorKanbanSelectReason from './kanban-fields/TutorKanbanSelectReason.vue'
import TutorKanbanSelectCategory from './kanban-fields/TutorKanbanSelectCategory.vue'
import TutorKanbanSelectAgent from './kanban-fields/TutorKanbanSelectAgent.vue'

defineOptions({
  name: 'TutorKanbanGeneralInfo',
})

const tutorKanbanStore = useTutorKanbanStore()
const listsStore = useListsStore()
</script>

<template>
  <div
    v-if="tutorKanbanStore.getTutor && listsStore.getLists"
    class="tkb-general-info"
  >
    <AppText name="body1-medium">
      General info
    </AppText>
    <TutorKanbanPreviousStage />
    <TutorKanbanSelectStage />
    <TutorKanbanSelectReason />
    <TutorKanbanSelectCategory />
    <TutorKanbanSelectPriority />
    <TutorKanbanPickerDeadline />
    <TutorKanbanSelectAgent />
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanGeneralInfo.scss" />
